import { AssetIcon } from "./AssetIcons";

interface AssetCardProps {
  name: string;
  balance: string;
  iconVariant?: "usdc" | "usdc-alt" | "usdt";
  tokenImage?: string;
  chainImage?: string;
  onClick?: () => void;
  selected?: boolean;
}

export function AssetCard({
  name,
  balance,
  iconVariant = "usdc",
  tokenImage,
  chainImage,
  onClick,
  selected,
}: AssetCardProps) {
  return (
    <button
      onClick={onClick}
      className={`flex w-full cursor-pointer items-center justify-between rounded-full px-10 py-20 transition-all md:px-14 md:py-24 ${
        selected ? "bg-muted/80 ring-1 ring-[#00EC97]" : "bg-muted/50 hover:bg-muted/70"
      }`}
      style={{
        background: selected
          ? "linear-gradient(135deg, rgba(42,42,42,0.9), rgba(26,26,26,0.9))"
          : "linear-gradient(135deg, rgba(42,42,42,0.5), rgba(26,26,26,0.5))",
      }}
    >
      <div className="flex items-center gap-3 md:gap-4">
        <AssetIcon iconVariant={iconVariant} tokenImage={tokenImage} chainImage={chainImage} />
        <span className="text-[18px] font-semibold text-[#fff] md:text-[20px]">{name}</span>
      </div>
      <span className="font-mono text-[18px] font-semibold text-[#00EC97] md:text-[20px]">{balance}</span>
    </button>
  );
}
